export default class CommonService {
  constructor(http) {
    this._resource = http;
  }
  bufferToBase64(buf) {
    var binstr = Array.prototype.map
      .call(buf, function(ch) {
        return String.fromCharCode(ch);
      })
      .join("");
    return btoa(binstr);
  }
  enviarEmail(id_nota, email, envXml, envDanfe, component, empr) {
    let url = "";

    switch (component) {
      case "NFSE":
        url = `nfses/email/${id_nota}/empr/${empr}?_emailTo=${email}`;
        break;
      case "CTE":
        url = `ctes/email/${id_nota}/empr/${empr}?_emailTo=${email}`;
        break;
      default:
        url = `nfes/danfe/email/${id_nota}/empr/${empr}?_emailTo=${email}`;
        break;
    }

    if (envXml && envDanfe) {
      url += `&_xml=${envXml}&_pdf=${envDanfe}`;
    } else if (envXml) {
      url += `&_xml=${envXml}`;
    } else if (envDanfe) {
      url += `&_pdf=${envDanfe}`;
    }
    return this._resource.get(url).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }

  getQntdNotasEmp(idEmp, component) {
    let url = "";

    switch (component) {
      case "CTE":
        url += `ctes/qnts/${idEmp}`;
        break;
      case "NFeRecebidas":
        url += `nfes/qnts/${idEmp}`;
        break;
      case "NFSE":
        url += `nfses/qnts/${idEmp}`;
        break;
      default:
        throw new Error(
          "Não foi possísvel setar url para buscar qntd de notas"
        );
    }
    return this._resource.get(url).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }

  zipEmailNotas(id_nota, email, envXml, envDanfe, component, empr) {
    let url = "";

    switch (component) {
      case "CTE":
        url += `ctes/email/multi/empr/${empr}`;
        break;
      case "NFeRecebidas":
        url += `nfes/email/multi/empr/${empr}`;
        break;
      case "NFSE":
        url += `nfses/email/multi/empr/${empr}`;
        break;
      default:
        throw new Error(
          "Não foi possísvel setar url para enivar multi arq email"
        );
    }
    url += `?_emailTo=${email}&_zip=true`;
    let acao = "";
    if (envXml) {
      acao += `xml`;
    }
    if (envDanfe) {
      acao += `-pdf`;
    }
    let body = JSON.stringify({ notas: id_nota, acao: acao });
    //debugger;
    return this._resource.post(url, body).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }

  getBase64File(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {};
    reader.onerror = function(error) {};

    return reader.result;
  }

  saveCustomColumn(id_nota, arrayColuna, component) {
    let url = "";
    switch (component) {
      case "CTE":
        url = `ctes/custom/${id_nota}`;
        break;
      case "NFeRecebidas":
        url = `nfes/custom/${id_nota}`;
        break;
      case "fornecedores":
        url = `fornecedores/custom/${id_nota}`;
        break;
      case "clientes":
        url = `clientes/custom/${id_nota}`;
        break;
      case "produtos":
        url = `produtos/custom/${id_nota}`;
        break;
      case "NFSE":
        url = `nfses/custom/${id_nota}`;
        break;
      default:
        return;
    }
    const body = JSON.stringify(arrayColuna);

    return this._resource.put(url, body).then(
      success => {
        return success.body;
      },
      failed => {}
    );
  }
  getLogConsulta(id_empresa, component, tipo) {
    let url = "";
    switch (component) {
      case "CTE":
        url = "ctes/logconsulta/" + id_empresa;
        break;
      case "NFeRecebidas":
        url = "nfes/logconsulta/" + id_empresa;
        break;
      case "NFSE":
        url = "nfses/logconsulta/" + id_empresa + "?_tipo=" + tipo;
        break;
      default:
        return;
    }
    return this._resource.get(url).then(
      success => {
        success.body.log = new Date(success.body.log);
        return success.body;
      },
      failed => {
        return failed;
      }
    );
  }
  saveHeadersByEmp(id_empresa, headers, component, tipo) {
    let url = "";
    switch (component) {
      case "CTE":
        url = `empresas/colunacte/${id_empresa}?tipo=${tipo}`;
        break;
      case "NFeRecebidas":
        url = `empresas/colunanfe/${id_empresa}?tipo=${tipo}`;
        break;
      case "fornecedores":
        url = `empresas/colunafornec/${id_empresa}`;
        break;
      case "clientes":
        url = `empresas/colunacliente/${id_empresa}`;
        break;
      case "produtos":
        url = `empresas/colunaproduto/${id_empresa}?tipo=${tipo}`;
        break;
      case "NFSE":
        url = `empresas/colunanfse/${id_empresa}?tipo=${tipo}`;
        break;
      default:
        return;
    }
    const body = JSON.stringify(headers);

    return this._resource.put(url, body).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/dataTable/commonService/CommonService.js